// extracted by mini-css-extract-plugin
module.exports = {"root":"IconPowerSettings_root__3W_Xi"};